import { render, staticRenderFns } from "./TabsWrapper.vue?vue&type=template&id=5e64e77a"
import script from "./TabsWrapper.vue?vue&type=script&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&lang=js"
import style0 from "./TabsWrapper.vue?vue&type=style&index=0&id=5e64e77a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports